import { usePageTitle } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { useSelector } from 'react-redux'

import { isSamlFeatureEnabledSelector } from './selectors'
import { SingleSignOnSetup } from './single_sign_on_setup'
import { Upgrade } from './upgrade'

export const SingleSignOnPage = () => {
  const isSamlFeatureEnabled = useSelector(isSamlFeatureEnabledSelector)
  const pageTitlePostfix = I18n.t('publisher.admin.login.title')

  usePageTitle(`${I18n.t('publisher.admin.login.tabs.sso')} - ${pageTitlePostfix}`)

  if (!isSamlFeatureEnabled) {
    return <Upgrade />
  }
  return <SingleSignOnSetup />
}
